function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
  fill: "#FFC107"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 15V5.2C5 5.08954 5.08954 5 5.2 5H7.1283C7.20949 5 7.28262 5.04908 7.31338 5.12422L9.26598 9.89297C9.39263 10.209 9.51353 10.5352 9.62867 10.8716C9.74381 11.1978 10.6419 13.7411 10.7686 14.0673L11 13.5L10.25 11.3L10.4059 10.8716C10.521 10.5352 10.6419 10.209 10.7686 9.89297L12.67 5.1259C12.7003 5.04988 12.7739 5 12.8558 5H14.8C14.9105 5 15 5.08954 15 5.2V15H13.152V10.4281C13.152 10.1937 13.1577 9.93884 13.1693 9.66361L13.2383 8.83792C13.2614 8.5525 13.2902 8.27727 13.3247 8.01223C13.3592 7.737 13.388 7.48216 13.4111 7.24771H13.342L12.4266 9.57186L11 13.5L10.7686 14.0673H9.38687L7.52159 9.57186L6.62349 7.24771H6.5544C6.57743 7.48216 6.60046 7.737 6.62349 8.01223C6.65803 8.27727 6.68682 8.5525 6.70984 8.83792C6.74439 9.11315 6.76741 9.38838 6.77893 9.66361C6.80196 9.93884 6.81347 10.1937 6.81347 10.4281V15H5Z",
  fill: "white"
});

var SvgMoneyIcon = function SvgMoneyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoneyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moneyIcon.e039c24c.svg";
export { ForwardRef as ReactComponent };